import classNames from "classnames";
import { useLongPress } from "use-long-press";
import type { FC } from "react";
import type { NotesListCardProps } from "../../model";
import { getCardClass } from "../../lib";
import styles from "./styles.module.scss";
import { NotesListCardHeader } from "./NotesListCardHeader";
import { NotesListCardBody } from "./NotesListCardBody";
import { NotesListCardFooter } from "./NotesListCardFooter";

export const NotesListCard: FC<NotesListCardProps> = ({
  cardData,
  selectedNotesIds,
  onStatusChange,
  onAvatarClick,
  onLongPress = () => "",
}) => {
  const handlers = useLongPress(() => {
    onLongPress(cardData);
  });

  return (
    <>
      <div
        className={classNames(
          styles["notes-list-card-root"],
          styles[
            getCardClass({
              dueDate: cardData.dueDate,
              status: cardData.status,
              direction: cardData.direction,
              noteType: cardData.noteType.name,
            })
          ],
        )}
        {...handlers()}
      >
        <NotesListCardHeader
          onAvatarClick={onAvatarClick}
          selectedNotesIds={selectedNotesIds}
          cardData={cardData}
          onStatusChange={onStatusChange}
        />
        <NotesListCardBody
          description={cardData.text ?? ""}
          important={cardData.important ?? false}
          title={cardData.title ?? ""}
        />
        <NotesListCardFooter
          noteType={cardData.noteType.name}
          date={cardData.noteDate}
          dueDate={cardData.dueDate}
          status={cardData.status}
          statusColor={""}
        />
      </div>
    </>
  );
};
